module.exports = __webpack_public_path__ + "static/media/watch-btn.99e87d63.png";